import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "carousel-more"
};
var _hoisted_2 = ["src"];
import { ref, computed, onMounted, nextTick, onActivated } from 'vue';
import 'swiper/css/scrollbar';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import constants, { encryptedMarketplaceId } from '@/constants';
import AsinItem from './AsinItem.vue';
import { getAsinBatch } from '@/models/api/detailPageApi';
import { useLess } from '@/models/hooks';
import { swiperDomTouchLogic, jumpInteractionType } from '@/utils/common';
import { useRouter } from 'vue-router';
import { batchGetAsinsData } from '@/utils/landingPageCommon';
var API_MAX_ASINS_LENGTH = 20;
export default {
  __name: 'HorizontalAsinShowCase',
  props: {
    asinItemClass: {
      type: String
    },
    asinIds: {
      type: Array
    },
    asinBadge: {
      type: String
    },
    isShowBuyButton: {
      type: Boolean
    },
    displayQuantity: {
      type: Number
    },
    moreIsShow: {
      type: Boolean
    },
    customTextContent: {
      type: String
    },
    interactionTypeInfo: {
      type: Array
    }
  },
  emits: ['onClickBuyPop'],
  setup(__props, {
    emit
  }) {
    var props = __props;
    useLess('views/landingPage/asinShowcase/TransverseShowcase.less');
    var router = useRouter();
    var asinList = ref([]);
    var asinSwiperItem = ref();
    var swiperRef = ref(null);
    var asinItemStyle = computed(() => {
      return _objectSpread({}, !props.isShowBuyButton && {
        height: 'auto'
      });
    });
    var onSwiper = swiper => {
      swiperRef.value = swiper;
    };
    var swiperDomTouch = () => {
      nextTick(() => {
        var _props$interactionTyp;
        if (!asinSwiperItem.value) {
          return;
        }
        var swiperDomList = asinSwiperItem.value[asinSwiperItem.value.length - 1].swiperRef.value.slides;
        var lastSwiperDom = swiperDomList[swiperDomList.length - 1];
        swiperDomTouchLogic(lastSwiperDom, jumpInteractionType(props === null || props === void 0 ? void 0 : (_props$interactionTyp = props.interactionTypeInfo) === null || _props$interactionTyp === void 0 ? void 0 : _props$interactionTyp[0], router));
      });
    };
    var getAsinList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var asinIdList, length, _data, _yield$getAsinBatch, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(props.displayQuantity === 0 || props.asinIds.length === 0)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              asinIdList = [];
              length = props.displayQuantity > props.asinIds.length ? props.asinIds.length : props.displayQuantity;
              asinIdList = props.asinIds.slice(0, length);
              if (!(asinIdList.length > API_MAX_ASINS_LENGTH)) {
                _context.next = 9;
                break;
              }
              try {
                // Fragment request, previous request completed, next request
                batchGetAsinsData(asinIdList, API_MAX_ASINS_LENGTH, asinList);
              } catch (error) {
                console.error(error, 'api---getAsinBatch---error');
              }
              _context.next = 21;
              break;
            case 9:
              _context.prev = 9;
              _context.next = 12;
              return getAsinBatch({
                ids: asinIdList.join(','),
                marketplace: encryptedMarketplaceId,
                withCache: true
              });
            case 12:
              _yield$getAsinBatch = _context.sent;
              data = _yield$getAsinBatch.data;
              data = (_data = data) === null || _data === void 0 ? void 0 : _data.filter(i => {
                var _i$availability;
                return i.selectionEligible && ((_i$availability = i.availability) === null || _i$availability === void 0 ? void 0 : _i$availability.status) !== constants.AVAILABILITY_STATUS_ENUM.OUT_OF_STOCK;
              });
              asinList.value.push(...data);
              _context.next = 21;
              break;
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](9);
              console.error(_context.t0, 'api---getAsinBatch---error');
            case 21:
              swiperDomTouch();
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[9, 18]]);
      }));
      return function getAsinList() {
        return _ref.apply(this, arguments);
      };
    }();
    var onClickBuyPop = item => {
      emit('onClickBuyPop', {
        merchantId: item.merchantId,
        selectedAsin: item.selectedAsin
      });
    };
    onMounted(() => {
      getAsinList();
    });
    onActivated(() => {
      var _swiperRef$value, _swiperRef$value$scro, _swiperRef$value$scro2;
      (_swiperRef$value = swiperRef.value) === null || _swiperRef$value === void 0 ? void 0 : (_swiperRef$value$scro = _swiperRef$value.scrollbar) === null || _swiperRef$value$scro === void 0 ? void 0 : (_swiperRef$value$scro2 = _swiperRef$value$scro.updateSize) === null || _swiperRef$value$scro2 === void 0 ? void 0 : _swiperRef$value$scro2.call(_swiperRef$value$scro);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Swiper), {
        modules: [_unref(Scrollbar)],
        class: "asin-swiper",
        "slides-per-view": "auto",
        ref_key: "swiperRef",
        ref: swiperRef,
        onSwiper: onSwiper,
        watchSlidesProgress: true,
        scrollbar: {
          hide: false
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(asinList.value, (asinItem, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            class: "swiper-slide-item",
            key: asinItem.id,
            ref_for: true,
            ref_key: "asinSwiperItem",
            ref: asinSwiperItem
          }, {
            default: _withCtx(() => [_createVNode(AsinItem, {
              style: _normalizeStyle(asinItemStyle.value),
              class: _normalizeClass([__props.asinItemClass, 'asin-item']),
              asinItem: asinItem,
              asinBadge: __props.asinBadge,
              isShowBuyButton: __props.isShowBuyButton,
              onOnClickBuyPop: onClickBuyPop
            }, null, 8, ["style", "class", "asinItem", "asinBadge", "isShowBuyButton"]), asinList.value.length > 1 && index == asinList.value.length - 1 && __props.moreIsShow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
              src: `${_unref(constants).IMAGE_URL}assets/image/icons/leftArrowBorder.png`
            }, null, 8, _hoisted_2), _createElementVNode("span", null, _toDisplayString(__props.customTextContent), 1)])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["modules"]);
    };
  }
};